// @flow
import React, { PureComponent } from 'react';
import { isEqual } from 'lodash';
import SideBillboardCard from 'components/billboard/SideBillboardCard';
// import CountDownHome from 'components/billboard/CountDownHome';
import BillBoardCard from 'components/billboard/BillboardCard';
import AlertContainer from 'containers/billboard/AlertContainer';
import BillboardMenuLinksContainer from 'containers/billboard/BillboardMenuLinksContainer';
import Hub from 'containers/hub/HubContainer';
import PartnersHub from 'containers/hub/ParnersContainer';
import SocialHubContainer from 'containers/social/SocialHubContainer';
import ParticipateContainer from 'containers/hub/ParticipateContainer';
import CompetitionHubContainer from 'containers/competition/CompetitionHubContainer';
import type { Status } from 'types/Status';
import type { ArticleType } from 'types/Article';
import { withHelmet } from 'infrastructure/seo/Helmet';
import Label from 'components/fragments/text/Label';
import BackgroundImage from 'components/fragments/BackgroundImage';
import { getDateFromString, formatFullDate } from 'utils/dateUtils';
import type { BlocContent } from 'types/NewsletterBloc';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import { nullPartner } from 'types/Settings';
import type { PartnerType } from 'types/Settings';

export type StateProps = {
  news: ArticleType[],
  status: Status,
  description: string,
  title: string,
  home: {
    title: string,
    content: BlocContent[],
  },
  actualite_une: {
    title: string,
    link: string,
    label: string,
    date: string,
    featured_image: string,
  },
  actualite_ffr_vers_ligues: {
    featured_media: {
      src: string,
      sizes: {}
    },
    date: string,
    link: string,
    title: {
      raw: string, 
      rendered: string
    },
    label: {
      name: string,
      slug: string,
    }
  },
  partenaires: PartnerType[],
};

export type DispatchProps = {
  fetchArticlesBillboard: () => void
};

type Props = StateProps & DispatchProps;

class Billboard extends PureComponent<Props> {
  componentDidMount() {
    this.props.fetchArticlesBillboard();
  }

  renderNews = (news: Array<ArticleType>): any => {
    return news.map(news => <SideBillboardCard key={news.title} row={true} content={news} />);
  };

  renderBlocsHome = () => {
    const { home } = this.props;
    return home.content.map((blocFigure, index) => {
      let classBloc = "col mt-2 col-lg-3";
      // $FlowFixMe
      if (blocFigure.attributes[0] && blocFigure.attributes[0].value === 'carte_ecosysteme')  {
        classBloc = "col mt-2 col-lg-12";
        // $FlowFixMe
        blocFigure.children[0].attributes[1].value = blocFigure.children[0].attributes[1].value.replace('mb-4', '');
      // $FlowFixMe
      } else if (blocFigure.attributes[0] && blocFigure.attributes[0].value === 'carte_ecosysteme col-lg-5')  {
        // $FlowFixMe
        blocFigure.attributes[0].value = "carte_ecosysteme ss-col";
        classBloc = "col mt-2 col-lg-3";
        // $FlowFixMe
        blocFigure.children[0].attributes[1].value = blocFigure.children[0].attributes[1].value.replace('card--small', '').replace('mb-4', '');
      // $FlowFixMe
      } else if (blocFigure.tagName === 'a' && blocFigure.attributes.length >= 3 && blocFigure.attributes[2].value.match('card--hub')) {
        classBloc = "col mt-2 col-lg-6";
        // $FlowFixMe
        blocFigure.attributes[2].value = blocFigure.attributes[2].value.replace('card--small', '').replace('mt-4', '').replace('mb-2', '');
      }
      return <div className={classBloc} key={index}><ContentBloc {...blocFigure} /></div>;
    });
  }

  render() {
    const {
      actualite_ffr_vers_ligues,
      actualite_une,
      news,
      partenaires,
      home,
    } = this.props;
    const news_forcee = actualite_ffr_vers_ligues && 
      actualite_ffr_vers_ligues.title && 
      actualite_ffr_vers_ligues.title.raw;

    const actualite_une_forcee = !news_forcee && actualite_une && actualite_une.title;

    const filteredTitle = actualite_une_forcee ? actualite_une.title : '';
    
    const noPartners = isEqual(nullPartner, partenaires[0]);
    return (
      <>
        <AlertContainer />
        <section className="container container--full billboard">
          <div className="billboard__wrapper clearfix">
            <div className="row">
              <div className="col col-md-8 col-lg-9">
                {news_forcee && 
                <a
                  title={`Lire la suite de l'article : ${actualite_ffr_vers_ligues.title.rendered}`}
                  href={`${actualite_ffr_vers_ligues.link}`}
                  target="_blank"
                  className="box card card--billboard"
                  rel="noopener noreferrer">
                  <BackgroundImage
                    className="card__thumbnail img-blue"
                    illustration={actualite_ffr_vers_ligues.featured_media.src}
                    srcset={actualite_ffr_vers_ligues.featured_media.sizes}
                  />
                  <div className="card__body">
                    <p className="card__date ft-h6">{formatFullDate(getDateFromString(actualite_ffr_vers_ligues.date+'.000Z'))}</p>
                    <h2 className="card__title">{actualite_ffr_vers_ligues.title.rendered}</h2>
                  </div>
                  <div className="card__footer">
                    <span className="btn btn--cheer">
                      <i className="icon icon-chevron-right link-icon is-inline" />
                      <span>Lire la suite</span>
                    </span>
                  </div>
                  <div className="card__type">
                    <Label label={actualite_ffr_vers_ligues.label.name} />
                  </div>
                </a>
                }
                {actualite_une_forcee && 
                <a
                  title={`Lire la suite de l'article : ${actualite_une.title}`}
                  href={`${actualite_une.link}`}
                  target="_blank"
                  className="box card card--billboard"
                  rel="noopener noreferrer">
                  <BackgroundImage
                    className="card__thumbnail img-blue"
                    illustration={actualite_une.featured_image}
                  />
                  <div className="card__body">
                    <p className="card__date ft-h6">{formatFullDate(getDateFromString(actualite_une.date+'.000Z'))}</p>
                    <h2 className="card__title">{actualite_une.title}</h2>
                  </div>
                  <div className="card__footer">
                    <span className="btn btn--cheer">
                      <i className="icon icon-chevron-right link-icon is-inline" />
                      <span>Lire la suite</span>
                    </span>
                  </div>
                  <div className="card__type">
                    <Label label={actualite_une.label} />
                  </div>
                </a>
                }
                {!news_forcee && !actualite_une_forcee  && 
                <BillBoardCard content={this.props.news[0]} />}
              </div>
              <div className="col col-md-4 col-lg-3">
                {news.filter((news) => news.title !== filteredTitle).length > 0 && (
                  <SideBillboardCard content={news.filter((news) => news.title !== filteredTitle)[0]} row={true} first={true} />
                )}
                {news.filter((news) => news.title !== filteredTitle).length > 1 && 
                  (this.renderNews(news.filter((news) => news.title !== filteredTitle).slice(1, 5))
                )}
              </div>
            </div>
            <BillboardMenuLinksContainer />
          </div>
          <div className="billboard__bg" />
        </section>
        {/* <CountDownHome message={`La Coupe du Monde de Rugby 2023 commence dans `} date='2023-09-08T19:15:00Z'/> */}
        {home && home.content && home.content.length > 0 && 
        <section className="container mt-md-7 mt-6">
          {home.title &&
          <h2 className="mb-3 text-inline">{home.title}</h2>}
          <div className="row">{this.renderBlocsHome()}</div>
        </section>}
        <Hub />
        <SocialHubContainer />
        <ParticipateContainer />
        {!noPartners && 
          <section className="section section-white has-half-bloc mb-7">
            <section className="container">
              <PartnersHub />
            </section>
          </section>}
        <CompetitionHubContainer />
      </>
    );
  }
}

export default withHelmet(Billboard)((Helmet, pageProps) => (
  <Helmet>
    <title>{pageProps.title}</title>
    <meta name={'description'} content={pageProps.description} />
    <link rel={'canonical'} href={window.location.href} />
  </Helmet>
));
